import { useState } from 'react';
import { postComment } from '../../provider/Blogs';
import { getArray, isTruthy } from '../../utils/helpers';
import pages from '../../subscriber/Pages';

const BlogCommentsForm = ({ blog, t}) => {
    const [form, setForm] = useState({
        name: '',
        message: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [errors, setErrors] = useState({name: '', comment: ''});

    const validate = () => {
        const newErrors = {name: '', comment: ''};
        if (!form?.name?.trim()) newErrors.name = 'nameRequired';
        if (!form?.comment?.trim()) newErrors.comment = 'messageRequired';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;
        setIsLoading(true);
        setMessage('');
        try {
            const requestBody = {
                name: form.name,
                message: form.message,
                post_id: blog.id
            }
            const response = await postComment(requestBody);
            const { status, result } = response;
            setIsLoading(false);
            setMessage(result);
            if (isTruthy(status)) {
                const { comments = [] } = blog;

                // Create updated blog object
                const updatedBlog = {
                    ...blog,
                    comments: [
                        ...comments,
                        {
                            name: form.name,
                            message: form.message,
                            created_at: new Date()
                        }
                    ]
                };

                // Replace the blog in blogs array
                const { blogs } = pages;
                const updatedBlogs = getArray(blogs).map(item =>
                    item.id === blog.id ? updatedBlog : item
                );

                // Update MobX store
                pages.updateValue("blogs", updatedBlogs);
                
                setIsSuccess(true);
                setForm({
                    name: '',
                    message: ''
                });
                return;
            }
            setIsSuccess(false);
        } catch (err) {
            console.error(err);
        }
    };
    
    return (
        <section id="blog_comments_form" className="py-20">
            <form onSubmit={handleSubmit} className="space-y-4">
                {message && (
                    <div
                        className={`rounded-md px-4 py-3 text-sm font-medium ${
                            isTruthy(isSuccess)
                                ? 'bg-green-100 text-green-800 border border-green-300'
                                : 'bg-red-100 text-red-800 border border-red-300'
                        }`}
                        role="alert"
                    >
                        {message}
                    </div>
                )}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <input
                            type="text"
                            name="name"
                            placeholder={t?.name}
                            value={form.name}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border rounded-md"
                        />
                        {errors.name && <p className="text-red-500 text-sm mt-1">{t[errors.name]}</p>}
                    </div>
                </div>
                <div>
                    <textarea
                        name="message"
                        placeholder={t?.messages}
                        rows="5"
                        value={form.message}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border rounded-md"
                    ></textarea>
                    {errors.comment && <p className="text-red-500 text-sm mt-1">{t[errors.comment]}</p>}
                </div>
                {isLoading ? 
                    <div className="h-6 w-6 border-4 border-[#d3752b] border-t-transparent rounded-full animate-spin" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    :
                    <button
                        type="submit"
                        className="border py-2 px-4 rounded-md transition duration-300"
                        style={{
                            borderColor: 'rgb(211, 117, 43)',
                            color: 'rgb(211, 117, 43)',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgb(211, 117, 43)';
                            e.currentTarget.style.color = 'white';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.color = 'rgb(211, 117, 43)';
                        }}
                    >
                        {t?.submit}
                    </button>
                }
            </form>
        </section>
    );
};

export default BlogCommentsForm;
